import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { concat } from 'rxjs/observable/concat';
import { ConfigurationService } from 'ionic-configuration-service';
import { AdminService } from '../services/admin.service';
import { SessionService } from '../services/session.service';
import { Platform } from 'ionic-angular';
import { RegionService } from '../services/region.service';

interface SettingOption {
  title: string;
  name: string;
  id?: string;
  type: string;
}

@Injectable()
export class AppInitService {
  defaultRegion: SettingOption;

  constructor(
    private configurationService: ConfigurationService,
    private adminService: AdminService,
    private sessionService: SessionService,
    private regionService: RegionService,
    public plt: Platform
  ) { }

  private loadDefaultConfigs(): Observable<void> {
    return new Observable<void>((observer) => {
      const defaultPath = 'assets/configs/default.json';
      this.configurationService.load(defaultPath).then(() => {
        this.defaultRegion = this.configurationService.getValue('region');
        observer.next();
        observer.complete();
      });
    });
  }

  init(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.loadDefaultConfigs().subscribe(
        () => { },
        (error: any) => reject(error),
        () => {
          this.services().subscribe(
            () => { },
            (err: any) => reject(err),
            () => {
              console.log('inited core services');
              resolve();
            }
          );
        }
      );
    });
  }

  services() {
    return concat(
      this.regionService.init('en'),
      this.adminService.init(),
      this.sessionService.init()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/app-init.service.ts